module.exports = __webpack_public_path__ + "img/tallerCerroNegro.64ab996e.svg";